// removed by extract-text-webpack-plugin
module.exports = {"TableWrapper":"_381c233wRmnBtqFVGZIbKm","Table":"_2ygTnv1zwWurqYgViDVp5m","Row":"umC_pZ19sSTAPSsRsHJ0x","Cell":"_3vd62yXbVa1tpsuuAmf7oS","DropdownCell":"_2S_UdyyJNzpur_GOZu9BDc","Icon":"_15I-4glTWnCqs_upd24Afr","HeadCell":"_33mmmyRkp5Dc_s0DM9ZtZb","HeadCellToggle":"_3a6YOdIjWUwUeYS1nhaiHa","InfoRow":"_1-2FuW-xVyieiH_9vd9dkP","Empty":"_1W9IEv9-sxcvYJnxyHHkk0","EmptyRow":"PEhvsFHMNdttqNPzQGBnu"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/RegistryList/styles.module.css
// module id = 575
// module chunks = 0